export const downloadFile = ( options ={}) => {
  const {
    url  = null 
  } = options

  var file_path = url;
  var a = document.createElement('A')
  a.href = file_path
  a.download = file_path.substr(file_path.lastIndexOf('/') + 1)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)

  return true
}